import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Button,
  Paper,
  Stack,
} from '@mui/material';
import { Cancel as CancelIcon } from '@mui/icons-material';
import AppMenu from '../components/AppMenu';

const CheckoutCancel: React.FC = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    // Get eventId from localStorage (stored before Stripe redirect)
    const eventId = localStorage.getItem('stripe_checkout_eventId');
    
    if (eventId) {
      // Clear the stored eventId
      localStorage.removeItem('stripe_checkout_eventId');
      // Navigate to the event page
      navigate(`/events/${eventId}`);
    } else {
      // Fallback to browser back if no eventId found
      navigate(-1);
    }
  };

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <Box>
      <AppMenu />
      
      <Container maxWidth="sm" sx={{ py: 8 }}>
        <Paper
          elevation={0}
          sx={{
            p: 4,
            borderRadius: 2,
            bgcolor: 'background.paper',
            boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
            border: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Stack spacing={4} alignItems="center">
            {/* Cancel Icon */}
            <Box
              sx={{
                width: 80,
                height: 80,
                borderRadius: '50%',
                bgcolor: 'error.main',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <CancelIcon
                sx={{
                  fontSize: 50,
                  color: 'white',
                }}
              />
            </Box>

            {/* Cancel Message */}
            <Box sx={{ textAlign: 'center' }}>
              <Typography
                variant="h4"
                component="h1"
                sx={{
                  fontWeight: 700,
                  color: 'text.primary',
                  mb: 2,
                }}
              >
                Payment Cancelled
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: 'text.secondary',
                  lineHeight: 1.6,
                }}
              >
                Your payment was cancelled. No charges have been made to your account.
              </Typography>
            </Box>

            {/* Action Buttons */}
            <Stack spacing={2} sx={{ width: '100%' }}>
              <Button
                variant="contained"
                size="large"
                fullWidth
                onClick={handleGoBack}
                sx={{
                  py: 1.5,
                  px: 3,
                  borderRadius: 2,
                  textTransform: 'none',
                  fontSize: '1rem',
                  fontWeight: 600,
                  bgcolor: '#EC4899',
                  '&:hover': {
                    bgcolor: '#DB2777',
                  },
                }}
              >
                Go Back
              </Button>
              
              <Button
                variant="outlined"
                size="large"
                fullWidth
                onClick={handleGoHome}
                sx={{
                  py: 1.5,
                  px: 3,
                  borderRadius: 2,
                  textTransform: 'none',
                  fontSize: '1rem',
                  fontWeight: 600,
                  borderColor: '#EC4899',
                  color: '#EC4899',
                  '&:hover': {
                    borderColor: '#DB2777',
                    color: '#DB2777',
                    bgcolor: 'transparent',
                  },
                }}
              >
                Go to Home
              </Button>
            </Stack>
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
};

export default CheckoutCancel;

